import { Button } from '@repo/ui/components/ui/button'
import { Card, CardContent } from '@repo/ui/components/ui/card'
import { Input } from '@repo/ui/components/ui/input'

interface BlogCTAProps {
  title?: string
  description?: string
  placeholder?: string
  buttonText?: string
}

export function BlogCTA({
  title = 'Stay Updated',
  description = 'Subscribe to our newsletter for the latest tutorials, tips, and product updates.',
  placeholder = 'your@email.com',
  buttonText = 'Subscribe',
}: BlogCTAProps) {
  return (
    <Card className="mx-auto mt-16 max-w-3xl bg-gradient-to-br from-primary/5 to-accent/5">
      <CardContent className="p-8 text-center">
        <h2 className="mb-3 text-2xl font-semibold">{title}</h2>
        <p className="mb-6 text-muted-foreground">{description}</p>
        <form className="mx-auto flex max-w-md flex-col gap-3 sm:flex-row">
          <Input type="email" placeholder={placeholder} className="flex-1" />
          <Button type="submit">{buttonText}</Button>
        </form>
      </CardContent>
    </Card>
  )
}
